import { render, staticRenderFns } from "./activityAssignments.html?vue&type=template&id=6f5c772d&external"
import script from "./activityAssignments.vue?vue&type=script&lang=js"
export * from "./activityAssignments.vue?vue&type=script&lang=js"
import style0 from "./activityAssignments.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports